import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import Select from "react-select";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const ExpenseReport = (props) => {
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const handleDropdownChange = (event) => {
    console.log(event, "event123");
    setSelectReport(event?.value);
  };

  const paramObject = useParams();

  console.log(responseData, "responseData127");

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        setLoading(false);
        return res;
      });
  }, []);

  //Function for export excel

  // to calculate the total

  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Openingbalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );
  console.log(reportdropdown, "reportdropdown");

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  // const columns = [
  //   {
  //     name: "Transcation date",
  //     selector: "Transactiondate",
  //     sortable: true,
  //   },
  //   {
  //     name: "Transcation type",
  //     selector: "Transactiontype",
  //     sortable: true,
  //   },
  //   {
  //     name: "Transcation number",
  //     // selector: "Transactionnumber",
  //     selector: (row) => row.Transactionnumber != '' ? row.Transactionnumber : '--',
  //     sortable: true,
  //   },
  //   {
  //     name: "Vendor name",
  //     selector: "Vendorname",
  //     sortable: true,
  //   },
  //   {
  //     name: "Due date",
  //     selector: (row) => row.DueDate != '' && row.DueDate != '0000-00-00' ? moment(row.DueDate).format('DD-MM-YYYY') : '--',
  //     sortable: true,
  //   },
  //   {
  //     name: "Amount",
  //     selector: "Amount",
  //     sortable: true,
  //     right: true,
  //   },
  //   {
  //     name: "Open balance",
  //     selector: (row) => Number(row.Openbalance).toFixed(2),
  //     sortable: true,
  //     right: true,
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "Transcation date",
      accessorKey: "Transactiondate",
      Cell: ({ row }) => {
        const transactionDate = moment(row.original.Transactiondate);
        if (transactionDate.isValid()) {
          return transactionDate.format("DD-MM-YYYY");
        } else {
          return "";
        }
      },
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Transcation type",
      accessorKey: "Transactiontype",
    },
    {
      header: "Transcation number",
      accessorKey: "Transactionnumber",
    },
    {
      header: "Vendor name",
      accessorKey: "Vendorname",
    },
    {
      header: "Due date",
      accessorKey: "DueDate",
      Cell: ({ row }) => {
        const DueDate = row?.original?.DueDate;
        if (DueDate === "0000-00-00" || DueDate === "" || DueDate === null) {
          return "";
        }
        return moment(DueDate).format("DD-MM-YYYY");
      },
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Open balance",
      accessorKey: "Openbalance",
    },
    {
      header: "Creted On",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("MM-DD-YYYY HH:mm:ss"),
    },
  ]);

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerDetail_.xlsx`);
  };
  // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  const apicall = () => {
    // const fetchData = async () => {
    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/expensereport?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData, "res======>");
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
          setRowCount(res.data.ResponseData[0].TotalRecord);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        setIsError(true);
        console.log(err);
        setLoading(false);
        return;
      });

    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    // }
    // fetchData();
  };

  useEffect(() => {
    apicall();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    // startdate,
    // enddate,
  ]);

  const downloadSlectedRowPDF = (rows) => {
    const newData = rows.map((row) => row.original);
    console.log(newData, "newData");
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">CustomerName</th>' +
        '<th style="padding: 7px;">Date</th>' +
        '<th style="padding: 7px; ">TransactionType</th>' +
        '<th style="padding: 7px; ">Transaction No.</th>' +
        '<th style="padding: 7px;">Name</th>' +
        '<th style="padding: 7px; ">Quantity</th>' +
        '<th style="padding: 7px; ">Rate</th>' +
        '<th style="padding: 7px; ">AmountLine</th>' +
        '<th style="padding: 7px; ">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Customername +
            "</td>" +
            '<td style="font-size: 6px; padding: 7px;">' +
            moment(newData[index - 1].DATE).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].TransactionType +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Transactionnumber +
            "</td>" +
            '<td style="font-size: 6px; ">' +
            newData[index - 1].Name +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Quantity +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            newData[index - 1].Rate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            Number(newData[index - 1].Amountline).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            Number(newData[index - 1].Balance).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Expense_Report.pdf");
        setLoading(false);
      },
    });
  };

  // Handle Print Button-
  const onBtPrint = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(data.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Date</th>' +
        '<th style="padding: 7px;">Type</th>' +
        '<th style="padding: 7px;">Number</th>' +
        '<th style="padding: 7px;">Vendor Name</th>' +
        '<th style="padding: 7px;">Due Date</th>' +
        '<th style="padding: 7px; text-align: right;">Amount</th>' +
        '<th style="padding: 7px; text-align: right;">Open Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= data.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Transactiondate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Transactiontype +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            Number(data[index - 1].Transactionnumber).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Vendorname +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(data[index - 1].DueDate).format("DD-MM-YYYY") +
            // data[index - 1].DueDate != '' && data[index - 1].DueDate != '0000-00-00' ? moment(data[index - 1].DueDate).format('DD-MM-YYYY') : '--' +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(data[index - 1].Openbalance).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
        setLoading(false);
      },
    });
  };

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `ExpenseReport_details_.xlsx`);
  };
  console.log(selectReport == 2);
  // Handle Download-
  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData;
    }
    console.log(newData, "newData");

    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Date</th>' +
        '<th style="padding: 7px;">Type</th>' +
        '<th style="padding: 7px;">Number</th>' +
        '<th style="padding: 7px;">Vendor Name</th>' +
        '<th style="padding: 7px;">Due Date</th>' +
        '<th style="padding: 7px; text-align: right;">Amount</th>' +
        '<th style="padding: 7px; text-align: right;">Open Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Transactiondate +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Transactiontype +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            Number(newData[index - 1].Transactionnumber).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Vendorname +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].DueDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(newData[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(newData[index - 1].Openbalance).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Expense_Report.pdf");
        setLoading(false);
      },
    });
  };
  console.log(reportdropdown, "reportdropdown");

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row">
              <h3 className="page-title">ExpenseReport</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">ExpenseReport</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <div className="form-group row">
                <label className="col-form-label col-md-4 form-label">
                  Report period
                </label>
                <div className="col-md-7">
                  <Select
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-primary pull-right"
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div>
          </div>

          {/* Receipt */}

          <div className="card mt-5" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h2>Sonar Pos</h2>
                  <p className="fw-bold">Expense Report</p>
                  <div className="row">
                    <p>
                      Date: {startdate} to {enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              {/* <div className="button mb-2">
                <button
                  onClick={onBtExport}
                  className="btn btn-sm btn-outline-dark  m-1"
                // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-excel me-2 lg"></i>
                  Export to Excel
                </button>
                <button
                  onClick={downloadPDF}
                  className="btn btn-sm btn-outline-dark  m-1"
                // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-export me-2 lg"></i>
                  Export to Pdf
                </button>
                <button
                  className="btn btn-sm btn-outline-dark  m-1"
                  onClick={onBtPrint}
                >
                   <i class="fas fa-print me-2 lg"></i>
                  Print
                </button>
              </div> */}

              {/* <div className="table-responsive">
                <DataTable
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  sortServer
                  dense
                />
              </div> */}

              <div>
                <MaterialReactTable
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  columns={columns}
                  data={responseData}
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    sorting: [{ id: "state", desc: false }], //sort by state by default
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300, 500],
                  }}
                  // manualFiltering
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters}
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  state={{
                    // columnFilters,
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={onBtExport}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Excel
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleExportRows(table.getSelectedRowModel().rows)
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Excel
                      </Button>
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={() => downloadPDF("", "alldata")}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Pdf
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          downloadPDF(
                            table.getSelectedRowModel().rows,
                            "selectedrow"
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Pdf
                      </Button>
                      {/* <Button
                        size="small"
                        onClick={() =>
                          // setPagination({ ...pagination, pageSize: totalRows })
                          setPagination({
                            ...pagination,
                            pageIndex: 0,
                            pageSize: rowCount,
                          })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                />
              </div>
              {/* <hr /> */}
              {/* <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpenseReport;
